<template>
	<s-modal-bottom-sheet
		v-model="show"
	>
		<template #activator="{ on }">
			<v-chip
				:color="$vuetify.theme.dark ? 'white' : 'black'"
				small
				outlined
				label
				v-on="on"
			>
				<v-icon>mdi-plus</v-icon>
			</v-chip>
		</template>

		<v-card>
			<v-card-title>Добавление артикула</v-card-title>
			<v-card-text>
				<v-form
					ref="form"
					@submit.stop.prevent="submit"
				>
					<v-text-field
						ref="codeInput"
						:rules="[v => (v || '').length > 0 || 'Заполните артикул']"
						label="Артикул"
						name="code"
						outlined
						dense
						autofocus
					/>
					<v-btn
						type="submit"
						outlined
						color="primary"
						v-text="'Сохранить'"
					/>
				</v-form>
			</v-card-text>
		</v-card>
	</s-modal-bottom-sheet>
</template>

<script>
import SModalBottomSheet from '@/components/base/s-modal-bottom-sheet';
export default {
	name: 'CreateNewVendorCode',
	components: { SModalBottomSheet },
	props: {
		product: {
			type: Object,
			required: true,
		},
	},
	data: () => ({
		loading: false,
		show: false,
	}),
	watch: {
		show(val) {
			if (!val) {
				this.$refs.form.reset();
			} else {
				this.$refs.form.resetValidation();
			}
		},
	},
	methods: {
		async submit() {
			if (this.loading || !this.$refs.form.validate()) return;
			this.loading = true;
			try {
				const response = await this.$http.post(`/api/v1/products/${this.product.id}/vendorCodes`, new FormData(this.$refs.form.$el), {
					params: {
						load: ['additionalVendorCodes'],
					},
				});

				this.$notify('Артикул добавлен');
				this.show = false;
				this.$emit('created', response.data.product.additional_vendor_codes)
			} finally {
				this.loading =false;
			}
		},
	},
};
</script>

<style scoped>

</style>
